/**
 * Small line icons for the match's own bar, where a phone has no room for words (the Beanstorm
 * staging run, 2026-10-30: "Sound on" and "Join voice" filled an upright phone's bar). Each sits
 * in a button that keeps its words as its name (`aria-label`, `title`), so screen readers and
 * hover say the same as before. Drawn in the text's colour.
 */

const ATTRS = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true",
  focusable: "false",
} as const;

const SPEAKER = <path d="M4 9h4l5-4v14l-5-4H4z" />;
const MIC = (
  <>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
  </>
);

export function SoundIcon({ on }: { on: boolean }) {
  return (
    <svg {...ATTRS}>
      {SPEAKER}
      {on ? (
        <path d="M16.5 9a4 4 0 0 1 0 6M19 6.5a8 8 0 0 1 0 11" />
      ) : (
        <path d="M17 9l5 6M22 9l-5 6" />
      )}
    </svg>
  );
}

export function MicIcon({ on }: { on: boolean }) {
  return (
    <svg {...ATTRS}>
      {MIC}
      {!on && <path d="M3 3l18 18" />}
    </svg>
  );
}

/** Joining voice: a headset, so it doesn't read as a mic that's already on or off. */
export function VoiceIcon() {
  return (
    <svg {...ATTRS}>
      <path d="M4 15v-3a8 8 0 0 1 16 0v3" />
      <rect x="3" y="14" width="4" height="6" rx="1.5" />
      <rect x="17" y="14" width="4" height="6" rx="1.5" />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg {...ATTRS}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M2 12h3M19 12h3M4.9 19.1 7 17M17 7l2.1-2.1" />
    </svg>
  );
}
